<p-toast></p-toast>
<div class="app-verification-container mt-2">
    <!-- <p-card styleClass="p-card-shadow"> -->
        <div class="card dashboardTable">
            <!-- <h4>{{'LISTOF_WATER_TANK_TO_BE_VERIFIED_(PFMS_MODULE)'| translate}}</h4> -->
            <p-toolbar styleClass="mb-4">
                <ng-template pTemplate="left">
                    <!-- <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                        class="p-button-success"></button> -->
                    <!-- <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button> -->
                </ng-template>
                <ng-template pTemplate="right">
                    <!-- <p-fileUpload accept=".jpeg,.pdf,.jpg" mode="basic" [maxFileSize]="5000000" label="Import" chooseLabel="Import" class="mr-2 inline-block"></p-fileUpload> -->
                    <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}" icon="pi pi-upload"
                        class="p-button-help"></button>
                    <button (click)="refreshTable()" pButton pRipple label="{{'REFRESH'| translate}}" icon="pi pi-refresh"
                        class="p-button-info ml-3"></button>
                    <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
                </ng-template>

            </p-toolbar>
            <p-table #tankTable [value]="tankData" [rows]="10" [paginator]="true"
                [globalFilterFields]="[
                'srNo', 
                'appID',
                'Applicant_type', 
                'FarmerName',
                'district', 
                'block', 
                'village',  
                'Total_Area', 
                'AgeOfApplication', 
                'PendingCompletedDays',
                'LandDetail', 
                'status', 
                'remarks' ,
                'DeptRemarks', 
                'FinYear',
                'AssignedDate',
                'ActionDate',
                'UserType',
                'Coverage_Area',
                'NoOfBeneficiary'
                ]"
                responsiveLayout="scroll" [(selection)]="tankData" [rowHover]="true" dataKey="id"
                currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                [showCurrentPageReport]="true" [loading]="loading" sortField="AssignedDate" [sortOrder]="1">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <h5 class="m-0">{{'LISTOF_WATER_TANK_TO_BE_VERIFIED_(PFMS_MODULE)'| translate}}</h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text"
                                (input)="tankTable.filterGlobal($any($event.target).value, 'contains')"
                                placeholder="{{'SEARCH'| translate}}" />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="">{{'VIEW_APPLICATION' | translate}}</th>

                        <!-- <th pSortableColumn="srNO">{{'S_NO'| translate}}
                            <p-columnFilter type="text" field="srNO" display="menu"></p-columnFilter>
                            <p-sortIcon field="srNO"></p-sortIcon>
                        </th> -->

                        <th pSortableColumn="appID">{{'APP_ID'| translate}}
                            <p-columnFilter type="text" field="appID" display="menu"></p-columnFilter>
                            <p-sortIcon field="appID"></p-sortIcon>
                        </th>

                        <th pSortableColumn="Applicant_type">{{'APPLICANT_TYPE'| translate}}
                            <p-columnFilter type="text" field="Applicant_type" display="menu"></p-columnFilter>
                            <p-sortIcon field="Applicant_type"></p-sortIcon>
                        </th>

                        <th pSortableColumn="FarmerName">{{'FARMER_NAME'| translate}}
                            <p-columnFilter type="text" field="FarmerName" display="menu"></p-columnFilter>
                            <p-sortIcon field="FarmerName"></p-sortIcon>
                        </th>

                        <th pSortableColumn="district">{{'DISTRICT' | translate}}
                            <p-columnFilter type="text" field="district" display="menu"></p-columnFilter>
                            <p-sortIcon field="district"></p-sortIcon>
                        </th>

                        <th pSortableColumn="block">{{'BLOCK' | translate}}
                            <p-columnFilter type="text" field="block" display="menu"></p-columnFilter>
                            <p-sortIcon field="block"></p-sortIcon>
                        </th>

                        <th pSortableColumn="village">{{'VILLAGE' | translate}}
                            <p-columnFilter type="text" field="village" display="menu"></p-columnFilter>
                            <p-sortIcon field="village"></p-sortIcon>
                        </th>



                        <th pSortableColumn="Total_Area">{{'TOTAL_AREA' | translate}}
                            <p-columnFilter type="text" field="Total_Area" display="menu"></p-columnFilter>
                            <p-sortIcon field="Total_Area"></p-sortIcon>
                        </th>

                        <th pSortableColumn="AgeOfApplication">{{'AGE_OF_APPLICATION' | translate}}
                            <p-columnFilter type="text" field="AgeOfApplication" display="menu"></p-columnFilter>
                            <p-sortIcon field="AgeOfApplication"></p-sortIcon>
                        </th>

                        <th pSortableColumn="AssignedDate">{{'ASSIGNED_DATE'| translate}}
                            <p-columnFilter type="text" field="AssignedDate" display="menu"></p-columnFilter>
                            <p-sortIcon field="AssignedDate"></p-sortIcon>
                        </th>
                        <th pSortableColumn="ActionDate">{{'ACTION_DATE'| translate}}
                            <p-columnFilter type="text" field="ActionDate" display="menu"></p-columnFilter>
                            <p-sortIcon field="ActionDate"></p-sortIcon>
                        </th>

                        <th pSortableColumn="PendingCompletedDays">{{'PENDING_COMPLETED_DAYS' | translate}}
                            <p-columnFilter type="text" field="PendingCompletedDays" display="menu"></p-columnFilter>
                            <p-sortIcon field="PendingCompletedDays"></p-sortIcon>
                        </th>

                        <th pSortableColumn="LandDetail">{{'LAND_DETAIL' | translate}}
                            <p-columnFilter type="text" field="LandDetail" display="menu"></p-columnFilter>
                            <p-sortIcon field="LandDetail"></p-sortIcon>
                        </th>

                        <th pSortableColumn="DeptRemarks">{{'REMARKS' | translate}}
                            <p-columnFilter type="text" field="DeptRemarks" display="menu"></p-columnFilter>
                            <p-sortIcon field="DeptRemarks"></p-sortIcon>
                        </th>

                        <th pSortableColumn="status">{{'STATUS' | translate}}
                            <p-columnFilter type="text" field="status" display="menu"></p-columnFilter>
                            <p-sortIcon field="status"></p-sortIcon>
                        </th>

                        <th pSortableColumn="Status_Ar">{{'CURRENT_STATUS' | translate}}
                            <p-columnFilter type="text" field="Status_Ar" display="menu"></p-columnFilter>
                            <p-sortIcon field="Status_Ar"></p-sortIcon>
                        </th>
                        <th pSortableColumn="UserType">{{'USER_TYPE' | translate}}
                            <p-columnFilter type="text" field="UserType" display="menu"></p-columnFilter>
                            <p-sortIcon field="UserType"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Coverage_Area">{{'COVERAGE_AREA' | translate}}
                            <p-columnFilter type="text" field="Coverage_Area" display="menu"></p-columnFilter>
                            <p-sortIcon field="Coverage_Area"></p-sortIcon>
                        </th>
                        <th pSortableColumn="NoOfBeneficiary">{{'NO_OF_BENEFICIARY' | translate}}
                            <p-columnFilter type="text" field="NoOfBeneficiary" display="menu"></p-columnFilter>
                            <p-sortIcon field="NoOfBeneficiary"></p-sortIcon>
                        </th>
                        <th pSortableColumn="FinYear">{{'FINANCIAL_YEAR'| translate}}
                            <p-columnFilter type="text" field="FinYear" display="menu"></p-columnFilter>
                            <p-sortIcon field="FinYear"></p-sortIcon>
                        </th>
                        <th>{{'ACTION' | translate}}</th>
                    </tr>

                </ng-template>

                <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                    <tr [ngStyle]="{'color': 'black', 'background-color': rowBackgroundColor(product)}">
                        <!-- <td>{{rowIndex + 1}}</td> -->
                        <td><button pButton pRipple pTooltip="view application" icon="pi pi-file"
                            class="p-button-rounded p-button-accent mr-1 btnSize"
                            (click)="selectFarmerApplication(product)"></button></td>
                        <td>{{product.appID}}</td>
                        <td>{{product.Applicant_type}}</td>
                        <td>{{product.FarmerName}}</td>
                        <td>{{product.district}}</td>
                        <td>{{product.block}}</td>
                        <td>{{product.village}}</td>
                        <td>{{product.Total_Area}}</td>
                        <td>{{product.AgeOfApplication}}</td>
                        <td>{{product?.AssignedDate | date:'medium'}}</td>
                        <td>{{product.ActionDate | date:'medium'}}</td>
                        <td>{{product.PendingCompletedDays}}</td>
                        <td>{{product.LandDetail}}</td>
                        <td>{{product.DeptRemarks}}</td>
                        <td>{{product.status}}</td>
                        <td>{{product.Status_Ar}}</td>
                        <td>{{product?.UserType}}</td>
                        <td>{{product?.Coverage_Area}}</td>
                        <td>{{product?.NoOfBeneficiary}}</td>
                        <td>{{product.FinYear}}</td>
                        <!-- <td
                            *ngIf="((product?.PondVerificationStatus == '1') || (product?.PondVerificationStatus == '2'))">
                            <button (click)="selectTankRowData(product)" pButton pRipple type="button"
                                label="Fill Details" class="p-button-success mr-2 mb-2"></button></td> -->
                        <td >
                            <button *ngIf="(product?.PondVerificationStatus == '1')" (click)="selectTankRowData(product)" icon="pi pi-pencil" pButton pRipple
                                type="button" class="p-button-rounded p-button-text"></button>
                                <button *ngIf="(product?.PondVerificationStatus == '2')" (click)="selectTankRowData(product)" icon="pi pi-fw pi-plus" pButton pRipple
                                type="button" class="p-button-rounded p-button-text"></button>
                        </td>


                        <!-- <td><button (click)="selectTankRowData2(product)" pButton pRipple type="button"
                                label="Fill Details" class="p-button-success mr-2 mb-2"></button></td> -->
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="flex  justify-content-between flex-column ">
                        <p>{{'IN_TOTAL_THERE_ARE' | translate}} {{tankData ? tankData.length : 0 }}
                            {{'APPLICATION_ADDED'| translate}}.
                        </p>
                        <div class="flex  justify-content-between flex-column ">
                            <div class="flex"><div style="background-color:#ff8080 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'PENDING_MORE_THAN_TWO_DAYS'| translate}}</div>
                            <div class="flex"><div style="background-color:#ffc966 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'PENDING_BY_ONE_DAY'| translate}}</div>
                            <div class="flex"><div style="background-color:#99e699 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'APROVED_ON_TIME'| translate}}</div>
                            <div class="flex"><div style="background-color:#ffb3b3 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'DELAYED_APPROVED'| translate}}</div>
                        </div>
                    </div>
                </ng-template>

            </p-table>
        </div>
    <!-- </p-card> -->
</div>

<p-dialog [(visible)]="displayTankDialog" [modal]="true" [style]="{width: '100%',height:'100%'}" [maximizable]="true"
    [draggable]="false" [resizable]="false" (onHide)="onCloseDialog()" [baseZIndex]="-100">
    <div class="app-verification-container">
        <p-card styleClass="p-card-shadow">
            <div class="field-checkbox justify-content-center">
                <label style="margin-right:4px;">{{'SELECT_ACTION'| translate }}</label>
                <p-dropdown [options]='[{name: "Tank Verification"}, {name: "False Intimation"}]' optionLabel="name"
                    (onChange)="wrongNotification($event)">
                </p-dropdown>
            </div>

            <div class="p-fluid p-formgrid justify-content-center mx-5" style="display: flex; flex-wrap:wrap">
                <div class="field md:col-4 col-12">
                    <label>{{'APPLICATION_ID'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)', fontSize:'1rem'}">{{appID}}</label></label>
                </div>
                <div class="field md:col-4 col-12">
                    <label>{{'APPLICANT_TYPE'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)', fontSize:'1rem'}">{{Applicant_type}}</label></label>
                </div>
                <div class="field md:col-4 col-12">
                    <label>{{'NO_OF_BENEFICIARY'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)', fontSize:'1rem'}">{{noOfBeneficiary}}</label></label>
                </div>
            </div>


            <!-- ESTIMATION FORM -->
            <div *ngIf="wrongNotificationCheck">
                <div class="col-12">
                    <div class="card estiamtion-header">
                        <form [formGroup]="submitEstimateForm">
                            <div class="p-fluid p-formgrid grid">
                                <!-- <div class="field col-12 md:col-2" *ngIf="wrongNotificationCheck">
                                        <label htmlFor="topSizeLength">Top Size:
                                            <div class="d-flex justify-content-around!important">
                                                <div
                                                    *ngIf="tankFormControls.topSizeLength.touched && tankFormControls.topSizeLength.valid">
                                                    Length : {{submitEstimateForm.get('topSizeLength').value}}
                                                </div>
                                                <div
                                                    *ngIf="tankFormControls.topSizeBreadth.touched && tankFormControls.topSizeBreadth.valid">
                                                    Breadth : {{submitEstimateForm.get('topSizeBreadth').value}}
                                                </div>
                                            </div>
                                        </label>
                                        <input  formControlName="topSizeLength" pInputText id="topSizeLength"
                                            type="number"  placeholder="Length"
                                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControls.topSizeLength.errors }" />
                                        <div *ngIf="isSubmitted && tankFormControls.topSizeLength.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="tankFormControls.topSizeLength.errors.required">Length is
                                                required
                                            </div>
                                        </div>

                                        <p class="text-center mt-3">X</p>

                                        <input formControlName="topSizeBreadth" pInputText id="topSizeBreadth"
                                            type="number" placeholder="Breadth"
                                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControls.topSizeBreadth.errors }" />


                                        <div *ngIf="isSubmitted && tankFormControls.topSizeBreadth.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="tankFormControls.topSizeBreadth.errors.required">Breadth is
                                                required
                                            </div>
                                        </div>
                                    </div> -->
                                <div class="field col-12 md:col-2" *ngIf="wrongNotificationCheck">
                                    <label htmlFor="topSizeLength">{{'TOP_SIZE_LENGTH'| translate}}:
                                    </label>
                                    <input formControlName="topSizeLength" pInputText id="topSizeLength" type="number"
                                        placeholder="Length"
                                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControls.topSizeLength.errors }" />
                                    <div *ngIf="isSubmitted && tankFormControls.topSizeLength.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="tankFormControls.topSizeLength.errors.required">{{'LENGTH_IS_REQUIRED'| translate}}
                                        </div>
                                    </div>
                                </div>

                                <div class="field col-12 md:col-2" *ngIf="wrongNotificationCheck">
                                    <label htmlFor="topSizeLength">{{'TOP_SIZE_BREADTH'| translate}}:
                                    </label>
                                    <input formControlName="topSizeBreadth" pInputText id="topSizeBreadth" type="number"
                                        placeholder="Breadth"
                                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControls.topSizeBreadth.errors }" />
                                    <div *ngIf="isSubmitted && tankFormControls.topSizeBreadth.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="tankFormControls.topSizeBreadth.errors.required">{{'BREADTH_IS_REQUIRED'| translate}}
                                        </div>
                                    </div>
                                </div>


                                <!-- <div class="field col-12 md:col-2" *ngIf="wrongNotificationCheck">
                                        <label htmlFor="bottomSizeLength">Bottom Size :
                                            <div
                                                *ngIf="tankFormControls.bottomSizeLength.touched && tankFormControls.bottomSizeLength.valid">
                                                Length : {{submitEstimateForm.get('bottomSizeLength').value}}
                                            </div>
                                            <div
                                                *ngIf="tankFormControls.bottomSizeBreadth.touched && tankFormControls.bottomSizeBreadth.valid">
                                                Breadth : {{submitEstimateForm.get('bottomSizeBreadth').value}}
                                            </div>
                                        </label>
                                        <input formControlName="bottomSizeLength" pInputText id="bottomSizeLength"
                                            type="number" placeholder="Length"
                                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControls.bottomSizeLength.errors }" />
                                        <div *ngIf="isSubmitted && tankFormControls.bottomSizeLength.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="tankFormControls.bottomSizeLength.errors.required">Length is
                                                required
                                            </div>
                                        </div>

                                        <p class="text-center mt-3">X</p>

                                        <input formControlName="bottomSizeBreadth" pInputText id="bottomSizeBreadth"
                                            type="number" placeholder="Breadth"
                                            [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControls.bottomSizeBreadth.errors }" />

                                        <div *ngIf="isSubmitted && tankFormControls.bottomSizeBreadth.errors"
                                            class="invalid-feedback">
                                            <div *ngIf="tankFormControls.bottomSizeBreadth.errors.required">Breadth is
                                                required
                                            </div>
                                        </div>
                                    </div> -->

                                <div class="field col-12 md:col-2" *ngIf="wrongNotificationCheck">
                                    <label htmlFor="bottomSizeLength">{{'BOTTOM_SIZE_LENGTH'| translate}}:
                                    </label>
                                    <input formControlName="bottomSizeLength" pInputText id="bottomSizeLength"
                                        type="number" placeholder="Length"
                                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControls.bottomSizeLength.errors }" />
                                    <div *ngIf="isSubmitted && tankFormControls.bottomSizeLength.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="tankFormControls.bottomSizeLength.errors.required">{{'LENGTH_IS_REQUIRED'| translate}}
                                        </div>
                                    </div>
                                </div>

                                <div class="field col-12 md:col-2" *ngIf="wrongNotificationCheck">
                                    <label htmlFor="bottomSizeLength">{{'BOTTOM_SIZE_BREADTH'| translate}}:
                                    </label>
                                    <input formControlName="bottomSizeBreadth" pInputText id="bottomSizeBreadth"
                                        type="number" placeholder="Breadth"
                                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControls.bottomSizeBreadth.errors }" />

                                    <div *ngIf="isSubmitted && tankFormControls.bottomSizeBreadth.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="tankFormControls.bottomSizeBreadth.errors.required">{{'BREADTH_IS_REQUIRED'| translate}}
                                        </div>
                                    </div>
                                </div>

                                <div class="field col-12 md:col-2" *ngIf="wrongNotificationCheck">
                                    <label htmlFor="depth">{{'DEPTH'}} : </label>
                                    <input formControlName="depth" pInputText id="depth" type="number"
                                        placeholder="Depth"
                                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControls.depth.errors }" />
                                    <div *ngIf="isSubmitted && tankFormControls.depth.errors" class="invalid-feedback">
                                        <div *ngIf="tankFormControls.depth.errors.required">{{'DEPTH_IS_REQUIRED'| translate}}
                                        </div>
                                    </div>
                                </div>

                                <div class="field col-12 md:col-2" *ngIf="wrongNotificationCheck">
                                    <label htmlFor="volumeOfEarthWork">{{'VOLUME_OF_EARTHWORK_CUM/CFT'| translate}} : </label>
                                    <input formControlName="volumeOfEarthWork" pInputText id="volumeOfEarthWork"
                                        type="number" placeholder="Volume of EarthWork"
                                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControls.volumeOfEarthWork.errors }" />
                                    <div *ngIf="isSubmitted && tankFormControls.volumeOfEarthWork.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="tankFormControls.volumeOfEarthWork.errors.required">{{'VOLUME_OF_EARTHWORK_IS_REQUIRED'| translate}}
                                        </div>
                                    </div>
                                </div>

                                <div class="field col-12 md:col-2" *ngIf="wrongNotificationCheck">
                                    <label htmlFor="totalCostOfEarthWork">{{'TOTAL_COST_OF_EARTH_WORK_AS_PER_MB_OF_JEE'| translate}} :
                                    </label>
                                    <input formControlName="totalCostOfEarthWork" pInputText id="totalCostOfEarthWork"
                                        type="number" placeholder="Enter Total cost of earthWork"
                                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControls.totalCostOfEarthWork.errors }" />
                                    <div *ngIf="isSubmitted && tankFormControls.totalCostOfEarthWork.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="tankFormControls.totalCostOfEarthWork.errors.required">{{'TOTAL_COST_OF_EARTHWORK_IS_REQUIRED'| translate}}
                                        </div>
                                    </div>
                                </div>

                                <div class="field col-12 md:col-3" *ngIf="wrongNotificationCheck">
                                    <label htmlFor="amountOfSubsidy">{{'TOTAL_AMOUNT_OF_SUBSIDY_(60%_OF_EARTH_WORK_EXECUTED_AS_PER_MB)'| translate}}:
                                    </label>
                                    <input formControlName="amountOfSubsidy" pInputText id="amountOfSubsidy"
                                        type="number" placeholder="Enter Amount of Subsidy"
                                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControls.amountOfSubsidy.errors }" />
                                    <div *ngIf="isSubmitted && tankFormControls.amountOfSubsidy.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="tankFormControls.amountOfSubsidy.errors.required">{{'AMOUNT_OF_SUBSIDY_IS_REQUIRED'| translate}}
                                           </div>
                                    </div>
                                </div>

                                <div class="field col-12 md:col-3" *ngIf="wrongNotificationCheck && (isDD_EW || isJE_EW || isDDTank || isAdmin)">
                                    <label htmlFor="StateShare_Amount">{{'STATE_SHARE_PAYMENT_AMOUNT'| translate}}:
                                    </label>
                                    <input readonly formControlName="StateShare_Amount"  pInputText id="StateShare_Amount"
                                        type="number" placeholder="State Share Amount"/>
                                </div>
                                <div class="field col-12 md:col-3" *ngIf="wrongNotificationCheck && (isDD_EW || isJE_EW || isDDTank || isAdmin)">
                                    <label htmlFor="CenterShare_Amount">{{'CENTER_SHARE_PAYMENT_AMOUNT'| translate}}:
                                    </label>
                                    <input readonly formControlName="CenterShare_Amount"  pInputText id="CenterShare_Amount"
                                        type="number" placeholder="Center Share Amount"/>
                                </div>
                                <div class="field col-12 md:col-3" *ngIf="wrongNotificationCheck && (isDD_EW || isJE_EW || isDDTank || isAdmin)">
                                    <label htmlFor="TopUp">{{'TOP_UP_AMOUNT'| translate}}:
                                    </label>
                                    <input readonly formControlName="TopUp"  pInputText id="TopUp"
                                    type="number" placeholder="Top Up Amount"/>
                                </div>
                                <div class="field col-12 md:col-3" *ngIf="wrongNotificationCheck && (isDD_EW || isJE_EW || isDDTank || isAdmin)">
                                    <label htmlFor="ABY">{{'ABY_AMOUNT'| translate}}:
                                    </label>
                                    <input readonly formControlName="ABY"  pInputText id="ABY"
                                        type="number" placeholder="ABY Amount"/>
                                </div>
                                <div class="field col-12 md:col-3" *ngIf="wrongNotificationCheck && (isDD_EW || isJE_EW || isDDTank || isAdmin)">
                                    <label htmlFor="Coverage_Area">{{'Coverage_Area'| translate}}:
                                    </label>
                                    <input readonly formControlName="Coverage_Area"  pInputText id="Coverage_Area"
                                        type="number" placeholder="Coverage Area"/>
                                </div>
                                
                                <!-- <div class="field col-12 md:col-4" *ngIf="router.url.startsWith('/je')"> -->
                                <!-- <div class="field col-12 md:col-2" *ngIf="PondVerData?.Table.length<0"> -->
                                <div class="field col-12 md:col-3"
                                    *ngIf="(router.url.startsWith('/je')) ||(router.url.startsWith('/sdo')) || (router.url.startsWith('/xen'))">
                                    <label htmlFor="block">{{'UPLOAD_MEASUREMENT_BOOK_COPY'| translate}} :</label>
                                    <div class="flex">
                                        <p-fileUpload accept=".jpeg,.pdf,.jpg" #measurementBookCopyPath
                                            [customUpload]="true"
                                            (uploadHandler)="onUpload($event, 'measurementBookCopyPath', measurementBookCopyPath,1)"
                                            name="myfile[]" mode="basic" [maxFileSize]="1000000" chooseLabel="Browse"
                                            [auto]="true">
                                        </p-fileUpload>
                                        <p-image *ngIf="tankFormControls.measurementBookCopyPath.value"
                                            [src]="tankFormControls.measurementBookCopyPath.value" alt="Image"
                                            width="60" class="ml-2 p-button-rounded p-button-success" iconPos="left">
                                        </p-image>

                                    </div>
                                    <div *ngIf="isSubmitted && tankFormControls.measurementBookCopyPath.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="tankFormControls.measurementBookCopyPath.errors.required">
                                            {{'MEASUREMENT_BOOK_COPY_IS_REQUIRED'| translate}}
                                        </div>
                                    </div>
                                </div>

                                <!-- <div class="field col-12 md:col-2" *ngIf="(router.url.startsWith('/je')) ||(router.url.startsWith('/sdo')) || (router.url.startsWith('/xen'))"> -->
                                <!-- <div class="field col-12 md:col-2" *ngIf="PondVerData?.length>0"> -->
                                <div class="field col-12 md:col-2" *ngIf="PondVerData">
                                    <!-- <div class="field col-12 md:col-2"> -->
                                    <label htmlFor="block">{{'MEASUREMENT_BOOK_COPY_UPLOADED_BY_JE'| translate}}:</label><br>
                                    <div class="flex" style="margin-top:8px;">
                                        <a style="cursor: pointer;" [href]="PondVerData?.estimateCopy"
                                            target="_blank">{{'VIEW_DOC'| translate}}</a>
                                    </div>
                                </div>
                                <div *ngIf="xenLogin || sdoLogin" class="field col-12 md:col-4">
                                    <label htmlFor="farmerName">{{'SURVEY_TYPE'| translate}}</label>
                                    <div class="field-radiobutton d-flex gap-2">
                                        <p-radioButton name="OfficeSurvey" [ngModelOptions]="{standalone: true}" value="0"
                                            (click)="getSurveyType(0)" [(ngModel)]="selectedSurveyType" inputId="0"></p-radioButton>
                                        <label for="0">From Office</label>
                                        <p-radioButton name="FieldSurvey" [ngModelOptions]="{standalone: true}" value="1"
                                        (click)="getSurveyType(1)" [(ngModel)]="selectedSurveyType" inputId="1"></p-radioButton>
                                    <label for="1">From Field</label>
                                    </div>
                                </div>
                                <!-- <div class="field col-12 md:col-2" *ngIf="wrongNotificationCheck && selectedSurveyType==1">
                                    <label htmlFor="latitude">{{'LATITUDE'| translate}} : </label>
                                    <input readOnly formControlName="latitude" pInputText id="latitude" type="number"
                                        placeholder="Latitude"
                                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControls.latitude.errors }" />
                                    <div *ngIf="isSubmitted && tankFormControls.latitude.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="tankFormControls.latitude.errors.required">{{'LATITUDE_IS_REQUIRED'| translate}}
                                        </div>
                                    </div>
                                    <p class="text-messageHide">{{'FIND_MY_CURRENT_LOCATION'| translate}}</p>                                                          
                                </div>
                                <div class="field col-12 md:col-2" *ngIf="wrongNotificationCheck  && selectedSurveyType==1">
                                    <label htmlFor="longitude">{{'LONGITUDE'| translate}}: </label>
                                    <input readOnly formControlName="longitude" pInputText id="longitude" type="number"
                                        placeholder="Longitude"
                                        [ngClass]="{ 'ng-invalid ng-dirty': isSubmitted && tankFormControls.longitude.errors }" />
                                    <div *ngIf="isSubmitted && tankFormControls.longitude.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="tankFormControls.longitude.errors.required">{{'LONGITUDE_IS_REQUIRED'| translate}}</div>
                                    </div>
                                    <p class="text-message" (click)="setCurrentPosition()">{{'FIND_MY_CURRENT_LOCATION'| translate}}</p>                              
                                </div> -->

                                <!-- JE Remarks -->
                                <!-- <div *ngIf="isAdmin || isDMICADA || isDDAssociate || xenLogin" class="field col-12 md:col-2 readOnly">
                                    <label htmlFor="pro-data">{{'JE_LATITUDE'| translate}}:</label>
                                    <p><label>{{ JElatitude }}</label></p>
                                </div>

                                <div *ngIf="isAdmin || isDMICADA || isDDAssociate || xenLogin" class="field col-12 md:col-2 readOnly">
                                    <label htmlFor="pro-data">{{'JE_LONGITUDE'| translate}}:</label>
                                    <p><label>{{ JElongitude }}</label></p>
                                </div> -->

                                <div *ngIf="isAdmin || isDMICADA || isDDAssociate || xenLogin" class="field col-12 md:col-4 readOnly">
                                    <label htmlFor="pro-data">{{'JE_REMARKS'| translate}}:</label>
                                    <p><label>{{ PondVerData?.JERemarks }}</label></p>
                                </div>
                                

                                <!-- XEN Remarks -->
                                <div *ngIf="isAdmin || isDMICADA || isDDAssociate" class="field col-12 md:col-4 readOnly">
                                    <label htmlFor="pro-data">{{'XEN_REMARKS'| translate}}:</label>
                                    <p><label>{{ PondVerData?.XENRemarks }}</label></p>
                                </div>

                                <div *ngIf="isAdmin || isDMICADA" class="field col-12 md:col-4 readOnly">
                                    <label htmlFor="pro-data">{{'DDASSOCIATE_REMARKS'| translate}}:</label>
                                    <p><label>{{ PondVerData?.DARemarks }}</label></p>
                                </div>

                                <div *ngIf="isAdmin" class="field col-12 md:col-4 readOnly">
                                    <label htmlFor="pro-data">{{'DMICADA_REMARKS'| translate}}:</label>
                                    <p><label>{{ PondVerData?.DMICADAReamrks }}</label></p>
                                </div>

                                <div *ngIf="isAdmin && adminUpdate" class="field col-12 md:col-4 readOnly">
                                    <label htmlFor="pro-data">{{'ADMIN_REMARKS'| translate}}:</label>
                                    <p><label>{{ PondVerData?.AdminRemarks }}</label></p>
                                </div>
                            </div>

                        </form>
                        <!-- <div class="readOnly p-fluid p-formgrid grid">
                            <div class="field col-12 md:col-2">
                                <label htmlFor="pro-data">{{'JE_Latitude'| translate}}:</label>
                                <p><label>{{ JElatitude }}</label></p>
                            </div>

                            <div class="field col-12 md:col-2">
                                <label htmlFor="pro-data">{{'JE_Longitude'| translate}}:</label>
                                <p><label>{{ JElongitude }}</label></p>
                            </div>
                        </div> -->
                    </div>

                    <div>
                        <span style="font-weight: bold;">{{'NOTE'| translate}}: </span>
                        <span style="color: #EA5455;">{{'PLEASE_FILL_THE_DETAILS_ACCORDING_TO_THE_MB_AND_TANK_FOUND_DURING_PHYSICAL_VERIFICATION'| translate}}.</span>
                    </div>

                    <!-- JE GPS coordinates start -->
                    <div class="gps-coordinate-container mt-2">
                        <div class="card">
                            <h5 *ngIf="!jeorxenLogin || xenLogin || sdoLogin">{{'JE_CAPTURED_GPS_COORDINATES' | translate}}({{'FENCING' |
                                translate}})</h5>
                            <h5 *ngIf="jeLogin">{{'CAPTURE_GPS_COORDINATES' | translate}}({{'FENCING' | translate}})</h5>
                            <div class="dashboardTable">
                                <ng-container *ngFor="let array of jegeolocationsarray; let i = index">
                                    <p-table [value]="array" [rows]="8" #geolocationsarrayTable showGridlines [tableStyle]="{ 'width': '30%' }"
                                        responsiveLayout="scroll" [rowHover]="true" [showCurrentPageReport]="true">
                                        <ng-template pTemplate="caption">
                                            <p>Table {{ i + 1}}</p>
                                        </ng-template>
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th>{{'CORNER_ID' | translate}}</th>
                                                <th>{{'LATITUDE'| translate}}</th>
                                                <th>{{'LONGITUDE'| translate}}</th>
                                                <th *ngIf="jeLogin && jegeolocationsarray.length - 1 == i">{{'ACTIONS'| translate}}</th>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                                            <tr>
                                                <td class="surveyEstimateTable">{{product.CornerID}}</td>
                                                <td class="surveyEstimateTable">{{product.lat}}</td>
                                                <td class="surveyEstimateTable">{{product.lng}}</td>
                                                <td *ngIf="jeLogin" class="surveyEstimateTable">
                                                    <button *ngIf="jegeolocationsarray.length - 1 == i" pButton pRipple type="button" icon="pi pi-times" (click)="onDeleteCoordinate('jeLogin', rowIndex, i)"
                                                        class="p-button-rounded p-button-text p-button-danger"></button>
                                                </td>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="summary" *ngIf="jeLogin">
                                            <button *ngIf="jegeolocationsarray.length - 1 == i" pButton pRipple type="submit" (click)="onCapture('jeLogin', i)" label="{{'CAPTURE_GPS_COORDINATES' | translate}}"
                                                class="p-button-info mr-2 mb-2"></button>
                                            <button *ngIf="jegeolocationsarray.length != 1" pButton pRipple type="submit" (click)="onDeleteNewPolygon('jeLogin', i)" label="{{'Delete Polygon' | translate}}"
                                                class="p-button-danger mr-2 mb-2"></button>
                
                                            <button *ngIf="jegeolocationsarray.length - 1 == i && jegeolocationsarray[i].length >= 4" pButton pRipple type="submit" (click)="onStartNewPolygon('jeLogin', i)" label="{{'Create New Polygon' | translate}}"
                                                class="p-button-warning mr-2 mb-2"></button>
                                        </ng-template>
                                    </p-table>
                                </ng-container>
                                <p-gmap  *ngIf="mapEnableJE" #gmap [style]="{'height':'300px', 'margin-bottom': '1em'}" [options]="jeMapoptions"
                                    [overlays]="jeMapoverlays" (onOverlayDragEnd)="onDrag('jeLogin', $event)"></p-gmap>
                            </div>
                            <div *ngIf="jeLogin" class="my-2 proDataButton flex justify-content-center">
                                <p class="invalid-feedback" *ngIf="jegeolocationsarray && jegeolocationsarray.length > 1 && coordinateError">{{coordinateError | translate}}</p>
                                <button pButton pRipple type="submit" (click)="onRefreshCurrentLocation('jeLogin')" label="{{'REFRESH_CURRENT_GPS_COORDINATES' | translate}}"
                                    class="p-button-secondary mr-2 mb-2"></button>
                            </div>
                        </div>
                        <div *ngIf="jeSurveyLandArea" class="my-2 proDataButton">
                            <p *ngIf="jegeolocationsarray && jegeolocationsarray?.[0]?.length >= 3" class="survey-area">Survey Area: {{ jeSurveyLandArea }} acre(s)</p>
                            <!-- <p *ngIf="jegeolocationsarray && jegeolocationsarray?.[0]?.length >= 3" class="survey-area">Survey Area: {{ jeSurveyLandArea }} acre(s)   ::   Apply Area: {{ landArea }} acre(s)</p> -->
                            <p class="invalid-feedback"
                                *ngIf="jegeolocationsarray && jegeolocationsarray?.[0]?.length < 4 && coordinateError">
                                {{coordinateError | translate}}</p>
                        </div>
                    </div>
                    <!-- JE GPS coordinates end -->

                    <!-- SDO GPS coordinates start -->
                    <div *ngIf="(sdoLogin && selectedSurveyType == 1) || !jeLogin && sdogeolocationsarray?.[0]?.length > 0" class="gps-coordinate-container">
                        <div class="card">
                            <h5 *ngIf="!(sdoLogin)">{{'SDO_CAPTURED_GPS_COORDINATES' | translate}}({{'FENCING' |
                                translate}})</h5>
                            <h5 *ngIf="sdoLogin">{{'CAPTURE_GPS_COORDINATES' | translate}}({{'FENCING' | translate}})</h5>
                            <div class="dashboardTable">
                                <ng-container *ngFor="let array of sdogeolocationsarray; let i = index">
                                    <p-table [value]="array" [rows]="8" #geolocationsarrayTable showGridlines [tableStyle]="{ 'width': '30%' }"
                                        responsiveLayout="scroll" [rowHover]="true" [showCurrentPageReport]="true">
                                        <ng-template pTemplate="caption">
                                            <p>Table {{ i + 1}}</p>
                                        </ng-template>
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th>{{'CORNER_ID' | translate}}</th>
                                                <th>{{'LATITUDE'| translate}}</th>
                                                <th>{{'LONGITUDE'| translate}}</th>
                                                <th *ngIf="sdoLogin && sdogeolocationsarray.length - 1 == i">{{'ACTIONS'| translate}}</th>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                                            <tr>
                                                <td class="surveyEstimateTable">{{product.CornerID}}</td>
                                                <td class="surveyEstimateTable">{{product.lat}}</td>
                                                <td class="surveyEstimateTable">{{product.lng}}</td>
                                                <td *ngIf="sdoLogin" class="surveyEstimateTable">
                                                    <button *ngIf="sdogeolocationsarray.length - 1 == i" pButton pRipple type="button" icon="pi pi-times" (click)="onDeleteCoordinate('sdoLogin', rowIndex, i)"
                                                        class="p-button-rounded p-button-text p-button-danger"></button>
                                                </td>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="summary" *ngIf="sdoLogin">
                                            <button *ngIf="sdogeolocationsarray.length - 1 == i" pButton pRipple type="submit" (click)="onCapture('sdoLogin', i)" label="{{'CAPTURE_GPS_COORDINATES' | translate}}"
                                                class="p-button-info mr-2 mb-2"></button>
                                            <button *ngIf="sdogeolocationsarray.length != 1" pButton pRipple type="submit" (click)="onDeleteNewPolygon('sdoLogin', i)" label="{{'Delete Polygon' | translate}}"
                                                class="p-button-danger mr-2 mb-2"></button>
                
                                            <button *ngIf="sdogeolocationsarray.length - 1 == i && sdogeolocationsarray[i].length >= 4" pButton pRipple type="submit" (click)="onStartNewPolygon('sdoLogin', i)" label="{{'Create New Polygon' | translate}}"
                                                class="p-button-warning mr-2 mb-2"></button>
                                        </ng-template>
                                    </p-table>
                                </ng-container>
                                <p-gmap  *ngIf="mapEnableSDO" #gmap [style]="{'height':'300px', 'margin-bottom': '1em'}" [options]="sdoMapoptions"
                                    [overlays]="sdoMapoverlays" (onOverlayDragEnd)="onDrag('sdoLogin', $event)"></p-gmap>
                            </div>
                            <div *ngIf="sdoLogin" class="my-2 proDataButton flex justify-content-center">
                                <p class="invalid-feedback" *ngIf="sdogeolocationsarray && sdogeolocationsarray.length > 1 && coordinateError">{{coordinateError | translate}}</p>
                                <button pButton pRipple type="submit" (click)="onRefreshCurrentLocation('sdoLogin')" label="{{'REFRESH_CURRENT_GPS_COORDINATES' | translate}}"
                                    class="p-button-secondary mr-2 mb-2"></button>
                            </div>
                        </div>
                        <div *ngIf="sdoSurveyLandArea" class="my-2 proDataButton">
                            <!-- <p *ngIf="sdogeolocationsarray && sdogeolocationsarray?.[0].length >= 3" class="survey-area">Survey Area: {{ sdoSurveyLandArea }} acre(s)   ::   Apply Area: {{ landArea }} acre(s)</p> -->
                            <p *ngIf="sdogeolocationsarray && sdogeolocationsarray?.[0].length >= 3" class="survey-area">Survey Area: {{ sdoSurveyLandArea }} acre(s)</p>
                            <p class="invalid-feedback"
                                *ngIf="sdogeolocationsarray && sdogeolocationsarray?.[0].length < 4 && coordinateError">
                                {{coordinateError | translate}}</p>
                        </div>
                    </div>
                    <!-- SDO GPS coordinates end -->

                    <!-- XEN GPS coordinates start -->
                    <div *ngIf="(xenLogin && selectedSurveyType == 1) || !(jeorxenLogin || sdoLogin)" class="gps-coordinate-container">
                        <div class="card">
                            <h5 *ngIf="!(jeorxenLogin || sdoLogin)">{{'XEN_CAPTURED_GPS_COORDINATES' | translate}}({{'FENCING' |
                                translate}})</h5>
                            <h5 *ngIf="xenLogin || sdoLogin">{{'CAPTURE_GPS_COORDINATES' | translate}}({{'FENCING' | translate}})</h5>
                            <div class="dashboardTable">
                                <ng-container *ngFor="let array of xengeolocationsarray; let i = index">
                                    <p-table [value]="array" [rows]="8" #geolocationsarrayTable showGridlines [tableStyle]="{ 'width': '30%' }"
                                        responsiveLayout="scroll" [rowHover]="true" [showCurrentPageReport]="true">
                                        <ng-template pTemplate="caption">
                                            <p>Table {{ i + 1}}</p>
                                        </ng-template>
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th>{{'CORNER_ID' | translate}}</th>
                                                <th>{{'LATITUDE'| translate}}</th>
                                                <th>{{'LONGITUDE'| translate}}</th>
                                                <th *ngIf="xenLogin && xengeolocationsarray.length - 1 == i">{{'ACTIONS'| translate}}</th>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                                            <tr>
                                                <td class="surveyEstimateTable">{{product.CornerID}}</td>
                                                <td class="surveyEstimateTable">{{product.lat}}</td>
                                                <td class="surveyEstimateTable">{{product.lng}}</td>
                                                <td *ngIf="xenLogin" class="surveyEstimateTable">
                                                    <button *ngIf="xengeolocationsarray.length - 1 == i" pButton pRipple type="button" icon="pi pi-times" (click)="onDeleteCoordinate('xenLogin', rowIndex, i)"
                                                        class="p-button-rounded p-button-text p-button-danger"></button>
                                                </td>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="summary" *ngIf="xenLogin">
                                            <button *ngIf="xengeolocationsarray.length - 1 == i" pButton pRipple type="submit" (click)="onCapture('xenLogin', i)" label="{{'CAPTURE_GPS_COORDINATES' | translate}}"
                                                class="p-button-info mr-2 mb-2"></button>
                                            <button *ngIf="xengeolocationsarray.length != 1" pButton pRipple type="submit" (click)="onDeleteNewPolygon('xenLogin', i)" label="{{'Delete Polygon' | translate}}"
                                                class="p-button-danger mr-2 mb-2"></button>
                
                                            <button *ngIf="xengeolocationsarray.length - 1 == i && xengeolocationsarray[i].length >= 4" pButton pRipple type="submit" (click)="onStartNewPolygon('xenLogin', i)" label="{{'Create New Polygon' | translate}}"
                                                class="p-button-warning mr-2 mb-2"></button>
                                        </ng-template>
                                    </p-table>
                                </ng-container>
                                <p-gmap  *ngIf="mapEnableXEN" #gmap [style]="{'height':'300px', 'margin-bottom': '1em'}" [options]="xenMapoptions"
                                    [overlays]="xenMapoverlays" (onOverlayDragEnd)="onDrag('xenLogin', $event)"></p-gmap>
                            </div>
                            <div *ngIf="xenLogin" class="my-2 proDataButton flex justify-content-center">
                                <p class="invalid-feedback" *ngIf="xengeolocationsarray && xengeolocationsarray.length > 1 && coordinateError">{{coordinateError | translate}}</p>
                                <button pButton pRipple type="submit" (click)="onRefreshCurrentLocation('xenLogin')" label="{{'REFRESH_CURRENT_GPS_COORDINATES' | translate}}"
                                    class="p-button-secondary mr-2 mb-2"></button>
                            </div>
                        </div>
                        <div *ngIf="xenLogin" class="my-2 proDataButton">
                            <!-- <p *ngIf="xengeolocationsarray && xengeolocationsarray?.[0].length >= 3" class="survey-area">Survey Area: {{ xenSurveyLandArea }} acre(s)   ::   Apply Area: {{ landArea }} acre(s)</p> -->
                            <p *ngIf="xengeolocationsarray && xengeolocationsarray?.[0].length >= 3" class="survey-area">Survey Area: {{ xenSurveyLandArea }} acre(s)</p>
                            <p class="invalid-feedback"
                                *ngIf="xengeolocationsarray && xengeolocationsarray?.[0].length < 4 && coordinateError">
                                {{coordinateError | translate}}</p>
                        </div>
                    </div>
                    <!-- XEN GPS coordinates end -->

                    <!-- Camera Section -->
                    <div>
                        <div  class="card" *ngIf="(router.url.startsWith('/je')) || ((router.url.startsWith('/xen') && selectedSurveyType == 1))"
                            style=" background-color: rgb(201,209,209);">
                            <h5 class="mt-0">{{'UPLOAD_ATTACHMENT'| translate}}</h5>
                            <div class="flex flex-wrap justify-content-center">
                                <!-- <div class="m-2">
                                        <p-dropdown [options]="uploadOptions" [(ngModel)]="selctedFileType"
                                            placeholder="Choose Document Type" optionLabel="name" [showClear]="true">
                                        </p-dropdown>

                                    </div> -->
                                <div class="m-2">
                                    <button (click)="openCamera()" pButton pRipple type="button" label="Capture"
                                        class="p-button-success mr-2 mb-2"></button>
                                </div>
                            </div>
                            <div>
                                <div>
                                    <div>
                                        <div class="document-list">
                                            <div class="document p-fluid p-formgrid grid mt-2"
                                                style="display: flex; flex-wrap:wrap;">
                                                <div *ngFor="let item of insertPondAttachments; let i=index"   class="field m-2 p-formgrid" key="index">
                                                    <span style="display: flex; justify-content: space-around">
                                                        <br>
                                                        <p style="margin-bottom: 0;"  target="_blank">{{item.displayName}} {{item.name}}</p>
                                                        <i class="pi pi-times cross-icon" (click)="removeCaptureImg(i)"></i>
                                                    </span>
                                                    <img [src]="item.attachmentRawUrl" [alt]="item.displayName"
                                                        style="max-width: 300px; max-height: 300px; display: block;cursor: pointer" />
                                                  </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <p-galleria [value]="PondVerData?.listImagePathJE" [(visible)]="displayCustom" [(activeIndex)]="activeIndex"
                            [responsiveOptions]="responsiveOptions" [containerStyle]="{'max-width': '850px'}"
                            [circular]="true" [fullScreen]="true" [showItemNavigators]="true" [showThumbnails]="false"
                            [baseZIndex]="100000">
                            <ng-template pTemplate="item" let-item>
                                <img [src]="item.ImagePath" style="width: 100%; display: block;" />
                            </ng-template>

                        </p-galleria>
                        <p-galleria [value]="PondVerData?.listImagePathXEN" [(visible)]="XENdisplayCustom" [(activeIndex)]="XENactiveIndex"
                        [responsiveOptions]="responsiveOptions" [containerStyle]="{'max-width': '850px'}"
                        [circular]="true" [fullScreen]="true" [showItemNavigators]="true" [showThumbnails]="false"
                        [baseZIndex]="100000">
                        <ng-template pTemplate="item" let-item>
                            <img [src]="item.ImagePath" style="width: 100%; display: block;" />
                        </ng-template>
                    </p-galleria>


                        <div class="card" *ngIf="prev && !jeLogin" style=" background-color: rgb(201,209,209);">
                            <h5 class="mt-0">{{'JE_ATTACHMENTS'| translate}}</h5>
                            <div class="document p-fluid p-formgrid grid" style="display: flex; flex-wrap:wrap;">
                                <div  class="field m-2" key="index"  *ngFor="let image of PondVerData?.listImagePathJE; let index = index;">
                                    <span style="display: flex; justify-content: space-around">
                                        <br>
                                        <p style="margin-bottom: 0;"  target="_blank">{{image.DocumentType}}</p>
                                    </span>
                                    <img [src]="image.ImagePath" [alt]="image.DocumentType"
                                        (click)="imageClick(index)" style="max-width: 300px; max-height: 300px; display: block;cursor: pointer" />
                                  </div>
                            </div>
                            <!-- </div> -->
                        </div>
                        <div class="card" *ngIf="XENprev && !xenLogin && !jeLogin" style=" background-color: rgb(201,209,209);">
                            <h5 class="mt-0">{{'XEN_ATTACHMENTS'| translate}}</h5>
                            <div class="p-fluid p-formgrid grid" style="display: flex; flex-wrap:wrap;">
                                <div  class="field m-2" key="index" *ngFor="let image of PondVerData?.listImagePathXEN; let index = index;" >
                                    <div>
                                        <span style="display: flex; justify-content: space-around">
                                            <br>
                                            <p style="margin-bottom: 0;"  target="_blank">{{image.DocumentType}}</p>
                                        </span>
                                        <img [src]="image.ImagePath" [alt]="image.DocumentType"
                                        (click)="XENimageClick(index)" style="max-width: 300px; max-height: 300px; display: block;cursor: pointer">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <p-dialog [(visible)]="displayCameraComponent" [modal]="true" [maximizable]="true"
                            [draggable]="false" [style]="{width: '98vw'}" [resizable]="false"
                            (onHide)="onCloseCameraDialog()">
                            <div *ngIf="displayCameraComponent">
                                <div class="camera-container">
                                    <div *ngIf="locationError" style="color: red; font-weight: bold;">
                                        {{locationError}}
                                    </div>
                                    <div *ngIf="!imageCaptured">
                                        <webcam [trigger]="triggerObservable" (imageCapture)="handleImage($event)"
                                            *ngIf="showWebcam" [allowCameraSwitch]="allowCameraSwitch"
                                            [switchCamera]="nextWebcamObservable" [videoOptions]="videoOptions"
                                            (cameraSwitched)="cameraWasSwitched($event)"
                                            (initError)="handleInitError($event)"></webcam>
                                        <br />
                                    </div>

                                    <h4 *ngIf="errors.length > 0">{{'MESSAGES'| translate}}:</h4>
                                    <ul *ngFor="let error of errors">
                                        <li>{{error | json}}</li>
                                    </ul>
                                </div>
                                <div class="webcam-btn" *ngIf="!imageCaptured">
                                    <button pButton pRipple type="button" label="capture" class="p-button-success m-2"
                                        (click)="triggerSnapshot()"></button>
                                    <button pButton pRipple type="button" label="switch camera"
                                        class="p-button-success m-2" (click)="showNextWebcam(true)"></button>
                                </div>
                                <div class="snapshot" *ngIf="imageCaptured">
                                    <img [src]="webcamImage.imageAsDataUrl" />
                                    <div *ngIf="fencingError" style="color: red; font-weight: bold; margin-top:10px;">
                                        {{fencingError}}
                                    </div>
                                </div>
                                <div class="webcam-btn" *ngIf="imageCaptured">
                                    <button pButton pRipple type="button" label="Upload" class="p-button-success m-2"
                                        (click)="uploadPicture()" [disabled]="!isInsideFencing"></button>
                                    <button pButton pRipple type="button" label="Retake" class="p-button-success m-2"
                                        (click)="retake()"></button>
                                </div>
                            </div>
                        </p-dialog>
                    </div>

                    <!-- Camera Section End -->



                </div>


                <div class="card dropdown-content" style="margin: 5px;">
                    <div class="p-fluid p-formgrid grid d-flex justify-content-end">
                        <div class="field col-12 md:col-4">
                            <br>
                            <p-dropdown [options]="items" [(ngModel)]="selectedStatus" optionLabel="status"
                                class="mr-3"></p-dropdown>
                        </div>
                        <div class="field col-12 md:col-2">
                            <textarea id="description" [(ngModel)]="stage1EstimateFormRemarks" placeholder="Remarks"
                                pInputTextarea required rows="3" cols="20" class="mr-3"></textarea>
                        </div>
                        <div class="field col-12 md:col-2">
                            <br>
                            <!-- <button pButton pRipple label="Submit" [disabled]="canEditPondData" type="submit" (click)="submitEstimate()"
                                    class="p-button-help"></button> -->
                            <button pButton pRipple label="Submit" type="submit" (click)="submitEstimate()"
                                class="p-button-help"></button>
                        </div>
                    </div>
                </div>
            </div>


            <ng-template [ngIf]="!wrongNotificationCheck">
                <div class="col-12">
                    <div class="card intimation-header">
                        <form [formGroup]="submitFalseIntimateForm" (onChange)="wrongNotification($event)">
                            <div class="p-fluid p-formgrid grid">
                                <div class="field col-12 md:col-2">
                                    <label htmlFor="uploadThePhotoTaken">{{'UPLOAD_THE_PHOTO_TAKEN'| translate}}* : </label>
                                    <div class="flex">
                                        <p-fileUpload accept=".jpeg,.pdf,.jpg" #uploadThePhotoTaken
                                            [customUpload]="true"
                                            (uploadHandler)="onUpload($event, 'uploadThePhotoTaken', uploadThePhotoTaken,2)"
                                            name="myfile[]" mode="basic" [maxFileSize]="1000000" chooseLabel="Browse"
                                            [auto]="true">
                                        </p-fileUpload>
                                        <p-image *ngIf="falseIntimationFormControls.uploadThePhotoTaken.value"
                                            [src]="falseIntimationFormControls.uploadThePhotoTaken.value" alt="Image"
                                            width="60" class="ml-2 p-button-rounded p-button-success" iconPos="left">
                                        </p-image>
                                    </div>
                                </div>


                                <!-- <div class="field col-12 md:col-2" *ngIf="(router.url.startsWith('/sdo')) || (router.url.startsWith('/xen'))">
                                        <label htmlFor="block">Photo taken:</label><br>
                                        <div class="flex" style="margin-top:8px;">
                                            <a style="cursor: pointer;" [href]="tankData[0]" target="_blank">View doc</a>
                                        </div>
                                    </div> -->
                            </div>
                            <div>
                                <span style="font-weight: bold;">{{'NOTE'| translate}}: </span>
                                <span style="color: #EA5455;">{{'ONLY_JPG,PNG_OR_PDF_PHOTO_ALLOWED'| translate}}.</span>
                            </div>
                        </form>
                    </div>
                </div>
                <br>
                <div class="card dropdown-content" style="margin: 5px;">
                    <div class="p-fluid p-formgrid grid d-flex justify-content-end">
                        <div class="field col-12 md:col-4">
                            <br>
                            <!-- <p-dropdown [options]="items" [(ngModel)]="selectedStatus" [disabled]="canEditPondData"
                                optionLabel="status" class="mr-3"></p-dropdown> -->
                            <p [style]="{'color': 'black'}"><b>{{ selectedStatusFalseIntimation?.status }}</b></p>
                        </div>
                        <div class="field col-12 md:col-2">
                            <textarea id="description" [(ngModel)]="stage1FalseIntimationremarks" placeholder="Remarks"
                                [disabled]="canEditPondData" pInputTextarea required rows="3" cols="20"
                                class="mr-3"></textarea>
                        </div>
                        <div class="field col-12 md:col-2">
                            <br>
                            <button pButton pRipple label="Submit" [disabled]="canEditPondData" type="submit"
                                (click)="submitFalseIntimate()" class="p-button-help"></button>
                        </div>
                    </div>
                </div>
            </ng-template>
            <!-- </div> -->
        </p-card>

        <div class="card mt-2" reflow="true">
            <div *ngIf="viewWorkFlowAllStatus">
                <app-work-flow-all-status [applicationId]="appID"></app-work-flow-all-status>
            </div>
            <button *ngIf="!viewWorkFlowAllStatus" pButton type="button" label="{{'VIEW_APPLICATION_STATUS' | translate}}"
                class="p-button-secondary" (click)="workFlowAllStatus()"></button>
        </div>
    </div>
</p-dialog>


<p-dialog [(visible)]="displayFileDialog" [modal]="true" [style]="{margin : '3rem'}" [maximizable]="true"
    [draggable]="false" [resizable]="true" (onHide)="onCloseFileDialog()">
    <ng-template pTemplate="header">
        <div>
            <button pButton pRipple icon="pi pi-search-plus" class="p-button-text"
                (click)="transformImage(null, 'zoom-in')" [disabled]="numberEquals(scalingAmount, 1)"></button><br />
            <button pButton pRipple icon="pi pi-search-minus" class="p-button-text"
                (click)="transformImage(null, 'zoom-out')" [disabled]="numberEquals(scalingAmount, '0.1')"></button>
        </div>
    </ng-template>
    <embed [src]="getSafeUrl()" style="width: 100%; height: 100%;" id="myname" #myname>

    <ng-template pTemplate="footer">
        <div class="flex flex-wrap align-items-center justify-content-center">
            <button pButton pRipple label="Rotate Left" icon="pi pi-angle-left" class="p-button-success"
                (click)="transformImage('left', null)"></button>
            <button pButton pRipple label="Rotate Right" icon="pi pi-angle-right" class="p-button-success"
                (click)="transformImage('right', null)"></button>
        </div>
    </ng-template>
</p-dialog>
